"use client"

import { useEffect } from 'react'
import { usePathname, useRouter } from 'next/navigation'
import { SiteHeader } from "@/components/site-header"
import { SiteFooter } from "@/components/site-footer"
import { NotFoundState } from "@/components/blocks/not-found-state"

export default function NotFound() {
  const pathname = usePathname()
  const router = useRouter()
  
  // Check if this is a known section that should show 404 page
  const isKnownSection = 
    pathname?.startsWith('/products') ||
    pathname?.startsWith('/collections') ||
    pathname?.startsWith('/tools') ||
    pathname?.startsWith('/blogs') ||
    pathname?.startsWith('/compare')

  // Redirect to homepage for unknown paths (e.g., /random-stuff)
  useEffect(() => {
    if (!isKnownSection) {
      router.replace('/')
    }
  }, [isKnownSection, router])

  // For unknown sections, show nothing while redirecting
  if (!isKnownSection) {
    return null
  }

  // Detect section from URL path
  const getSection = (): 'product' | 'collection' | 'tool' | 'blog' => {
    if (pathname?.startsWith('/products')) return 'product'
    if (pathname?.startsWith('/collections')) return 'collection'
    if (pathname?.startsWith('/tools')) return 'tool'
    if (pathname?.startsWith('/blogs')) return 'blog'
    return 'product' // fallback (shouldn't reach here due to isKnownSection check)
  }

  return (
    <div className="min-h-screen bg-white">
      <SiteHeader />
      <div className="container mx-auto px-4 py-8">
        <NotFoundState section={getSection()} />
      </div>
      <SiteFooter />
    </div>
  )
}
